import React from 'react';

// import '@ant-design/compatible/assets/index.css';


import { Col, FormInstance, Row } from 'antd';
import DF from 'DisplayFramework';
import FormInput from 'components/FormInput';
import TextArea from 'antd/lib/input/TextArea';

import ParListSelect from 'components/ParListSelect/ParListSelect';
import Checkbox from 'components/Checkbox/Checkbox';

export type TabAssetFvDuplicateProps = {
  form?: FormInstance;
  objectid?: number;
  objectreference?: string;
};

const TabAssetFvDuplicate = ({ objectid, form }: TabAssetFvDuplicateProps) => {
  form?.setFieldsValue({
    event: 'tabAssetFvDuplicate',
  });

  return (
    <DF.Provider pagcode="tabAssetFvDuplicate">
      <Row style={{ marginTop: '20px' }}>
        <Col span={24}>
          <Row gutter={32}>
            <FormInput
              col
              name="contextcode"
              xl={12}
              rules={[{ required: true }]}
            >
              <ParListSelect parcode="FVCONTEXT" allowAddValue />
            </FormInput>

            <FormInput col name="flagreplace2" xl={4} valuePropName="checked">
              <Checkbox
                onChange={(e) => {
                  form?.setFieldsValue({ flagreplace: e.target.checked });
                }}
                comcode="flagreplace"
              />
            </FormInput>
            <FormInput col name="reason" xl={8}>
              <ParListSelect parcode="FVCTXREAS" allowAddValue />
            </FormInput>
          </Row>
          <Row gutter={30}>
            <Col span={24}>
              <FormInput name="comment" rules={[{ required: true }]}>
                <TextArea maxLength={255} rows={5} cols={300} />
              </FormInput>
            </Col>
          </Row>
        </Col>
      </Row>
    </DF.Provider>
  );
};
export default TabAssetFvDuplicate;
